var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { CarManageService } from "~/services/domain-service/car-manage.service";
import AddGarage from '~/components/car-management/add-garage.vue';
var GarageManagement = /** @class */ (function (_super) {
    __extends(GarageManagement, _super);
    function GarageManagement() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.dataForm = {
            garageCode: "",
            garageName: "",
            addressDetail: "",
            contactName: "",
            contactPhone: "",
            commonState: ""
        };
        _this.dialog = {
            show: false
        };
        _this.grageObj = {};
        return _this;
    }
    GarageManagement.prototype.mounted = function () {
        this.refreshData();
    };
    GarageManagement.prototype.refreshData = function () {
        var _this = this;
        this.carManageService
            .getAllGarages(this.dataForm, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    GarageManagement.prototype.onClickAddCar = function () {
        this.dialog.show = true;
    };
    GarageManagement.prototype.onClickEdit = function (row) { };
    __decorate([
        Dependencies(PageService)
    ], GarageManagement.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], GarageManagement.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CarManageService)
    ], GarageManagement.prototype, "carManageService", void 0);
    GarageManagement = __decorate([
        Auth(1531),
        Layout('workspace'),
        Component({
            components: {
                AddGarage: AddGarage,
            }
        })
    ], GarageManagement);
    return GarageManagement;
}(Vue));
export default GarageManagement;
